<template>
	<div class="ks-heading-tabs-wrapper" style="margin-top: 5px;">
		<div class="ks-heading-tabs" :class="{ 'ks-heading-tabs-grow': grow, 'ks-heading-tabs-large': large }">
			<div class="ks-tabs-list">
				<template v-for="(tab, index) in tabs">
					<k-menu v-if="hasSubmenu(tab)" :key="'submenu-' + index" offset-y>
						<template #activator>
							<div class="ks-tab ks-tab-with-submenu" :class="{ 'is-active': isActiveTab(index), 'is-disabled': tab.disabled }">
								<span>{{ tab.label }}</span>
								<k-icon small>arrow_drop_down</k-icon>
							</div>
						</template>
						<template #default>
							<scoped-slot-renderer
								v-if="hasSubmenuSlot(tab)"
								:renderer="tab.$scopedSlots.submenu"
								:slot-props="getSubmenuSlotProps(tab, index)"
							/>
							<k-list v-else :items="tab.submenu" @click="(item) => selectSubmenu(index, item)">
								<template #default="{ item }">
									{{ item.label }}
								</template>
							</k-list>
						</template>
					</k-menu>
					<div v-else :key="'tab-' + index" class="ks-tab" :class="{ 'is-active': isActiveTab(index), 'is-disabled': tab.disabled }" @click="selectTab(index)">
						{{ tab.label }}
					</div>
				</template>
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
var ScopedSlotRenderer = {
	functional: true,
	props: {
		renderer: {
			type: Function,
			default: null
		},
		slotProps: {
			type: Object,
			default: function () { return {} }
		}
	},
	render: function (h, ctx) {
		if (!ctx.props.renderer) return null
		return ctx.props.renderer(ctx.props.slotProps || {})
	}
}

export default {
	components: {
		ScopedSlotRenderer
	},
	props: {
		"value": {
			type: [Number, String],
			default: 0
		},
		"grow": {
			type: Boolean,
			default: false
		},
		"large": {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			tabs: [],
			currentTab: this.value
		}
	},
	watch: {
		value (val) {
			this.currentTab = val
			this.updateTabs()
		},
		currentTab (val) {
			this.updateTabs()
		},
		"$route" () {
			this.syncWithRoute()
		}
	},
	methods: {
		hasSubmenuItems (tab) {
			return !!(tab && Array.isArray(tab.submenu) && tab.submenu.length > 0)
		},
		hasSubmenuSlot (tab) {
			return !!(tab && tab.$scopedSlots && tab.$scopedSlots.submenu)
		},
		hasSubmenu (tab) {
			return this.hasSubmenuItems(tab) || this.hasSubmenuSlot(tab)
		},
		getSubmenuSlotProps (tab, tabIndex) {
			var self = this
			return {
				tab: tab,
				tabIndex: tabIndex,
				currentTab: this.currentTab,
				select: function (value, to) {
					self.selectSubmenuValue(tabIndex, value, {
						item: { value: value, to: to },
						to: to
					})
				},
				selectSubmenu: function (item) {
					self.selectSubmenu(tabIndex, item)
				}
			}
		},
		getSubmenuItemValue (tab, submenuItem, submenuIndex, tabIndex) {
			if (submenuItem && typeof submenuItem.value !== "undefined") return submenuItem.value
			if (submenuItem && typeof submenuItem.name !== "undefined") return submenuItem.name
			if (submenuItem && submenuItem.to && typeof submenuItem.to === "string") return submenuItem.to
			if (submenuItem && submenuItem.to && typeof submenuItem.to === "object") {
				if (submenuItem.to.name) return submenuItem.to.name
				if (submenuItem.to.path) return submenuItem.to.path
			}
			if (tab && tab.name) return tab.name + "-" + submenuIndex
			return "tab-" + tabIndex + "-" + submenuIndex
		},
		isRouteMatch (to, route) {
			if (!to || !route) return false
			if (typeof to === "string") {
				return route.path === to
			}
			if (typeof to === "object") {
				if (to.path && route.path === to.path) return true
				if (to.name && route.name === to.name) return true
			}
			return false
		},
		syncWithRoute () {
			var path = this.$route && this.$route.path
			if (!path) return
			for (var i = 0; i < this.tabs.length; i++) {
				var tab = this.tabs[i]
				if (this.hasSubmenuItems(tab)) {
					for (var j = 0; j < tab.submenu.length; j++) {
						var submenuItem = tab.submenu[j]
						if (!submenuItem || !submenuItem.to) continue
						if (this.isRouteMatch(submenuItem.to, this.$route)) {
							var submenuVal = this.getSubmenuItemValue(tab, submenuItem, j, i)
							if (this.currentTab !== submenuVal) {
								this.currentTab = submenuVal
								this.$emit("input", submenuVal)
							}
							return
						}
					}
				}
				if (!tab.to) continue
				var tabPath = typeof tab.to === "string" ? tab.to : (tab.to.path || "")
//				if (tabPath && path === tabPath) {
				if (tabPath && path.startsWith(tabPath)) {

					var val = tab.name || i
					if (this.currentTab !== val) {
						this.currentTab = val
						this.$emit("input", val)
					}
					return
				}
				// Match by route name
				if (typeof tab.to === "object" && tab.to.name && this.$route.name === tab.to.name) {
					var val2 = tab.name || i
					if (this.currentTab !== val2) {
						this.currentTab = val2
						this.$emit("input", val2)
					}
					return
				}
			}
		},
		isActiveTab (index) {
			var tab = this.tabs[index]
			if (tab && this.hasSubmenuItems(tab)) {
				for (var i = 0; i < tab.submenu.length; i++) {
					var val = this.getSubmenuItemValue(tab, tab.submenu[i], i, index)
					if (this.currentTab === val) return true
				}
			}
			if (tab && tab.name) {
				return this.currentTab === tab.name
			}
			return this.currentTab === index
		},
		registerTab (tab) {
			// Insert in DOM order
			var index = this.getTabDomIndex(tab)
			if (index === -1 || index >= this.tabs.length) {
				this.tabs.push(tab)
			} else {
				this.tabs.splice(index, 0, tab)
			}
			this.updateTabs()
		},
		unregisterTab (tab) {
			var index = this.tabs.indexOf(tab)
			if (index !== -1) {
				this.tabs.splice(index, 1)
			}
		},
		selectTab (index) {
			var tab = this.tabs[index]
			if (tab && tab.disabled) return
			if (tab && this.hasSubmenu(tab)) return
			var val = (tab && tab.name) ? tab.name : index
			this.currentTab = val
			this.$emit("input", val)
			this.$emit("change", val)
			this.updateTabs()
			if (tab && tab.to) {
				this.$router.push(tab.to).catch(function () {})
			}
		},
		selectSubmenu (tabIndex, submenuItem) {
			var tab = this.tabs[tabIndex]
			if (!tab || tab.disabled || !submenuItem || submenuItem.disabled) return
			var submenuIndex = tab.submenu.indexOf(submenuItem)
			var val = this.getSubmenuItemValue(tab, submenuItem, submenuIndex, tabIndex)
			this.selectSubmenuValue(tabIndex, val, {
				item: submenuItem,
				to: submenuItem.to || tab.to
			})
		},
		selectSubmenuValue (tabIndex, value, payload) {
			var tab = this.tabs[tabIndex]
			if (!tab || tab.disabled) return
			this.currentTab = value
			this.$emit("input", value)
			this.$emit("change", value)
			this.$emit("submenu-change", {
				tab: tab,
				tabIndex: tabIndex,
				item: payload && payload.item ? payload.item : null,
				value: value
			})
			this.updateTabs()
			var target = payload && payload.to ? payload.to : tab.to
			if (target) {
				this.$router.push(target).catch(function () {})
			}
		},
		updateTabs () {
			this.tabs.forEach((tab, i) => {
				if (this.hasSubmenu(tab)) {
					tab.isActive = this.isActiveTab(i)
					return
				}
				if (tab.name) {
					tab.isActive = this.currentTab === tab.name
				} else {
					tab.isActive = this.currentTab === i
				}
			})
		},
		getTabDomIndex (tab) {
			if (!tab.$el) return -1
			var allTabEls = this.$el.querySelectorAll(".ks-tab-content")
			for (var i = 0; i < allTabEls.length; i++) {
				if (allTabEls[i] === tab.$el) return i
			}
			return -1
		}
	},
	mounted () {
		this.syncWithRoute()
		this.updateTabs()
	}
}
</script>

<style>
.ks-heading-tabs .ks-tabs-list {
	scrollbar-width: none;
}
.ks-heading-tabs-large {
	padding-top: 6px;
	padding-bottom: 6px;
}

.ks-heading-tabs .ks-tabs-list::-webkit-scrollbar {
	display: none;
}

.ks-heading-tabs-grow .ks-tabs-list {
	width: 100%;
}
.ks-heading-tabs-grow .ks-tab {
	flex: 1;
}

.ks-tab.is-disabled {
	opacity: 0.4;
	cursor: not-allowed;
	pointer-events: none;
}

.ks-tab-with-submenu {
	display: flex;
	align-items: center;
	gap: 2px;
}

/* k-menu wrapper must fill the list height so the tab's height: 100% works */
.ks-tabs-list > .ks-menu {
	display: flex;
	height: 100%;
}
.ks-tabs-list > .ks-menu > .ks-menu-activator {
	height: 100%;
}
</style>
